import clsx from 'clsx'

import { Box, Grid, TextField, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import useFormatNumber from '../../../i18n/useFormatNumber'
import { getFieldProps } from '../../../common/formProps'
import { makeFormPropTypes } from '../../../common/formikPropTypes'
import { shippingSend4ServicesPropTypes } from '../../../common/propTypes'

import FormLayout from './FormLayout'
import useStyles from './styles'
import Checkbox from '../../../ui/components/checkbox'
// import SwitchLabel from '../../../ui/components/switchLabel'
import FormatNumberField from '../../../ui/components/formatNumberField'
import Divider from '../../../ui/components/divider'

import {
  MAX_REFUND_AMOUND_ALLOWED,
  MAX_INSURANCE_VALUE_ALLOWED,
} from '../../../context/ShippingSend/step4constants'

const Step4AdditServices = ({
  values,
  fieldErrors,
  touched,
  onChange,
  onBlur,
  international,
  isPudo,
}) => {
  const t = useTranslations()
  const formatNumber = useFormatNumber()
  const classes = useStyles()

  return (
    <FormLayout>
      <Box component="section" className={classes.section}>
        <div>
          <Typography variant="h2" className={clsx('decorator', classes.title)}>
            {t('noun:additional-services-title')}
          </Typography>
          <Typography className={classes.paragraphStatement}>
            {t('noun:additional-services-description')}
          </Typography>
        </div>
        {/* <Box component="section" className={classes.section}>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <Box pl={0.5}>
              <SwitchLabel
                label={t('field:optional', {
                  field: t('noun:declared-value'),
                  span: text => (
                    <Box component="span" sx={styles.optionalLabel}>
                      {text}
                    </Box>
                })}
                subLabel="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras aliquet enim vitae sollicitudin malesuada. "
              />
            </Box>
          </Grid>
          <Grid item xs={6} className={classes.serviceOptions}>
            <TextField
              className={classes.inputService}
              name="declaredValue"
              label={t('noun:declared-value')}
              placeholder={`0${t('field:money-suffix')}`}
              InputProps={{
                inputComponent: FormatNumberField,
                inputProps: {
                  onChange,
                  name: 'declaredValue',
                  suffix: t('field:money-suffix'),
                },
              }}
              {...getFieldProps(
                'declaredValue',
                values,
                fieldErrors,
                touched,
                t,
              )}
              helperText={
                touched.declaredValue && fieldErrors.declaredValue
                  ? t(
                      fieldErrors.declaredValue.key,
                      fieldErrors.declaredValue.values,
                    )
                  : t('helper:max-amount', { amount: MAX_DECLARED_VALUE })
              }
              onBlur={onBlur}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider /> */}
        {!international && !isPudo && (
          <div>
            <Box component="section" className={classes.section}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <Checkbox
                    name="withRefund"
                    label={t('noun:refund')}
                    subLabel={t('noun:refund-description', {
                      formattedAmount: formatNumber(MAX_REFUND_AMOUND_ALLOWED),
                    })}
                    checked={values.withRefund}
                    onChange={onChange}
                  />
                </Grid>
                <Grid item xs={6} className={classes.serviceOptions}>
                  <TextField
                    className={classes.inputService}
                    name="refundAmount"
                    label={t('noun:refund-amount')}
                    placeholder={`0${t('field:money-suffix')}`}
                    InputProps={{
                      inputComponent: FormatNumberField,
                      inputProps: {
                        onChange,
                        name: 'refundAmount',
                        suffix: t('field:money-suffix'),
                      },
                    }}
                    {...getFieldProps(
                      'refundAmount',
                      values,
                      fieldErrors,
                      touched,
                      t,
                    )}
                    // TODO:  i18n: revisar mensaje de error en consola, sobre formattedAmount, al salir del input
                    helperText={
                      touched.refundAmount && fieldErrors.refundAmount
                        ? t(
                            fieldErrors.refundAmount.key,
                            fieldErrors.refundAmount.createValues !== undefined
                              ? fieldErrors.refundAmount.createValues(
                                  formatNumber,
                                )
                              : undefined,
                          )
                        : t('helper:max-amount', {
                            formattedAmount: formatNumber(
                              MAX_REFUND_AMOUND_ALLOWED,
                            ),
                          })
                    }
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={!values.withRefund}
                  />
                </Grid>
              </Grid>
            </Box>

            <Divider />
          </div>
        )}
        <div>
          <Box component="section" className={classes.section}>
            <Grid container spacing={4}>
              <Grid item xs={6}>
                <Checkbox
                  name="insuranceMerchandise"
                  label={t('noun:additional-coverage')}
                  subLabel={
                    international
                      ? t(
                          'noun:additional-coverage-description-international',
                          {
                            formattedAmount: formatNumber(
                              MAX_INSURANCE_VALUE_ALLOWED,
                            ),
                          },
                        )
                      : t('noun:additional-coverage-description-national', {
                          formattedAmount: formatNumber(
                            MAX_INSURANCE_VALUE_ALLOWED,
                          ),
                        })
                  }
                  checked={values.insuranceMerchandise}
                  onChange={onChange}
                />
              </Grid>
              <Grid item xs={6} className={classes.serviceOptions}>
                <TextField
                  className={classes.inputService}
                  name="insuranceValue"
                  label={t('noun:declared-value')}
                  placeholder={`0${t('field:money-suffix')}`}
                  InputProps={{
                    inputComponent: FormatNumberField,
                    inputProps: {
                      onChange,
                      name: 'insuranceValue',
                      suffix: t('field:money-suffix'),
                    },
                  }}
                  {...getFieldProps(
                    'insuranceValue',
                    values,
                    fieldErrors,
                    touched,
                    t,
                  )}
                  // TODO:  i18n: revisar mensaje de error en consola, sobre formattedAmount, al salir del input
                  helperText={
                    touched.insuranceValue && fieldErrors.insuranceValue
                      ? t(
                          fieldErrors.insuranceValue.key,
                          fieldErrors.insuranceValue.createValues !== undefined
                            ? fieldErrors.insuranceValue.createValues(
                                formatNumber,
                              )
                            : undefined,
                        )
                      : t('helper:max-amount', {
                          formattedAmount: formatNumber(
                            MAX_INSURANCE_VALUE_ALLOWED,
                          ),
                        })
                  }
                  onChange={onChange}
                  onBlur={onBlur}
                  disabled={!values.insuranceMerchandise}
                />
              </Grid>
            </Grid>
          </Box>
        </div>
        {!international && !isPudo && (
          <div>
            <Divider />
            <Box component="section" className={classes.section}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <Checkbox
                    name="withReturn"
                    label={t('service:with-return')}
                    subLabel={t('noun:additional-return')}
                    checked={values.withReturn}
                    onChange={onChange}
                  />
                </Grid>
                {/* <Grid item xs={6} className={classes.serviceOptions}>
              <Box mb={2}>
                <Checkbox
                  name="returnWithHandling"
                  label={t('service:with-handling')}
                  subLabel="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras aliquet enim vitae sollicitudin malesuada."
                  checked={values.returnWithHandling}
                  onChange={onChange}
                />
              </Box>
              <Box>
                <Checkbox
                  name="item2"
                  label="Item2"
                  subLabel="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras aliquet enim vitae sollicitudin malesuada."
                  checked={values.item2}
                  onChange={onChange}
                />
              </Box>
            </Grid> */}
              </Grid>
            </Box>
          </div>
        )}
        {!international && !isPudo && (
          <div>
            <Divider />
            <Box component="section" className={classes.section}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <Checkbox
                    name="scanClientSlip"
                    label={t('service:scan-client-slip')}
                    subLabel={t('noun:additional-slip-scan')}
                    checked={values.scanClientSlip}
                    onChange={onChange}
                  />
                </Grid>
                {/* <Grid item xs={6} className={classes.serviceOptions}>
              <Checkbox
                name="item3"
                label="Item3"
                subLabel="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras aliquet enim vitae sollicitudin malesuada."
                checked={values.item3}
                onChange={onChange}
              />
            </Grid> */}
              </Grid>
            </Box>
          </div>
        )}
        {/* <Divider />
        <Box component="section" className={classes.section}>
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <Checkbox
                name="verifyCode"
                label={t('service:verify-code')}
                subLabel="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras aliquet enim vitae sollicitudin malesuada."
                checked={values.verifyCode}
                onChange={onChange}
              />
            </Grid>
          </Grid>
        </Box> */}
      </Box>
    </FormLayout>
  )
}

Step4AdditServices.propTypes = {
  ...makeFormPropTypes(shippingSend4ServicesPropTypes),
}

export default Step4AdditServices
